/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import { formValue } from "../../../services/formServiceFunctions";
import _ from "lodash";
import SpecialBurden from "./SpecialBurden/SpecialBurden";
import useForm from "../../../hooks/useForm";
import ValidatorForm from "../../Validator/ValidatorForm";
import ValidatorSelect from "../../Validator/ValidatorSelect";
import MenuItem from "@mui/material/MenuItem";
import SubmitButton from "../../Button/SubmitButton";
import { Box, SelectChangeEvent } from "@mui/material";
import { processCostSupportStyle } from "../processCostSupportStyle";
import { ProcessCostSupportFormProps } from "../../../types/ProcessCostSupport";

const SpecialBurdens = ({ pcs, onSubmit, isLoading }: ProcessCostSupportFormProps) => {
  const empty = {
    description: "",
    petitionerShare: "",
  };

  const initialValues = {
    hasSpecialFinancialBurdens: pcs.hasSpecialFinancialBurdens,
    specialFinancialBurdens: !_.isEmpty(pcs.specialFinancialBurdens) ? pcs.specialFinancialBurdens : [empty],
  };

  const { values, handleChange, handleSubmit, errors, touchedValues, handleBlur } = useForm({
    initialValues,
    onSubmit,
    identifier: pcs,
  });

  const add = () => {
    const specialFinancialBurdens = values.specialFinancialBurdens || [];
    if (specialFinancialBurdens.length >= 2) {
      return;
    }

    specialFinancialBurdens.push(empty);

    handleChange({
      target: {
        type: "other",
        name: "specialFinancialBurdens",
        value: specialFinancialBurdens,
      },
    });
  };

  const handleMore = ({ target }: SelectChangeEvent) => {
    const { name, value } = target;
    if (value === "yes") {
      add();
    }
    if (value === "no") {
      const splitName = _.split(name, "-");
      const lastPart = splitName[splitName.length - 1];
      const key = parseInt(lastPart);
      handleChange({
        target: {
          type: "other",
          name: "specialFinancialBurdens",
          value: _.slice(values.specialFinancialBurdens, 0, key + 1),
        },
      });
    }
  };

  return (
    <>
      <Box sx={processCostSupportStyle.sectionHeadline}>Finanzielle Belastungen</Box>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid container sx={processCostSupportStyle.grid}>
          <Grid sx={processCostSupportStyle.question} size={12}>
            Haben Sie andere besondere finanzielle Belastungen, die bisher nicht abgefragt wurden?
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}>
            <ValidatorSelect
              label={"Finanzielle Belastungen"}
              name={"hasSpecialFinancialBurdens"}
              value={formValue(values, "hasSpecialFinancialBurdens")}
              onChange={handleChange}
              onBlur={handleBlur}
            >
              <MenuItem value={"no"}>Nein</MenuItem>
              <MenuItem value={"yes"}>Ja</MenuItem>
            </ValidatorSelect>
          </Grid>
          {formValue(values, "hasSpecialFinancialBurdens") === "yes" && (
            <>
              {_.map(values.specialFinancialBurdens, (specialBurden, key) => (
                <React.Fragment key={key}>
                  <SpecialBurden
                    path={`specialFinancialBurdens[${key}]`}
                    specialBurden={specialBurden}
                    handleChange={handleChange}
                  />
                  {parseInt(key) < 1 && (
                    <>
                      <Grid sx={processCostSupportStyle.question} size={12}>
                        Haben Sie eine weitere besondere finanzielle Belastung?
                      </Grid>
                      <Grid
                        size={{
                          xs: 12,
                          md: 6,
                          lg: 4
                        }}>
                        <ValidatorSelect
                          label={"Weitere Belastung?"}
                          name={`hasMore-${key}`}
                          value={formValue(values, "specialFinancialBurdens").length - 1 > parseInt(key) ? "yes" : "no"}
                          onChange={handleMore}
                          onBlur={handleBlur}
                        >
                          <MenuItem value={"no"}>Nein</MenuItem>
                          <MenuItem value={"yes"}>Ja</MenuItem>
                        </ValidatorSelect>
                      </Grid>
                    </>
                  )}
                </React.Fragment>
              ))}
            </>
          )}
          <Grid size={12}>
            <SubmitButton
              error={_.keys(errors).length > 0}
              isLoading={isLoading}
              disabled={_.keys(touchedValues).length === 0}
              variant={"contained"}
              type={"submit"}
            >
              Änderungen speichern
            </SubmitButton>
          </Grid>
        </Grid>
      </ValidatorForm>
    </>
  );
};

export default SpecialBurdens;
